module.exports = {
	"name": "youboralib",
	"type": "lib",
	"tech": "js",
	"author": "Jordi Aguilar",
	"version": "6.0.0",
	"built": "2017-06-01",
	"repo": "https://bitbucket.org/npaw/lib-plugin-js.git"
};


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0